<template>
  <div v-if="isLoaded" class="animated fadeIn accelerator-requests">
    <!-- loading component -->
    <Loading />
    <b-card style="border: 0" class="mt-0 mb-0 common-card">
      <h3>کد طرح: {{ proposal.requestsCode }}</h3>
      <h4 class="text-dark">وضعیت طرح: {{ proposal.status }}</h4>
      <hr />
      <v-btn
        style="float: left"
        v-if="tabIndex == 0"
        class="bc-purple"
        @click="saveDocx('doc')"
        elevation="0"
      >
        <v-icon small class="fa fa-file-word-o pe-2 white--text"></v-icon>
        <span class="white--text text-capitalize"> دریافت Word </span>
      </v-btn>
      <!-- docx -->
      <div v-show="false" id="doc">
        <div class="all" style="text-align: right">
          <h1
            style="
              display: inline-block;
              text-align: center;
              padding: 5px 0;
              border-bottom: 3px solid black;
            "
          >
            کد طرح:
            <span style="direction: ltr; font-family: Bahnschrift SemiBold">{{
              proposal.requestsCode
            }}</span>
          </h1>
          <div>
            <h2 style="color: black; direction: rtl">
              تاریخ خروجی:
              <span style="direction: rtl">{{ exportDate }}</span>
            </h2>
            <hr />
            <h2 style="display: inline-block; text-align: center; color: blue">
              عنوان و حمایت‌های پیشین
            </h2>
            <div>
              <ul>
                <li>
                  <strong class="c-purple">عنوان به زبان فارسی: </strong>
                  {{ proposal.faSubject }}
                </li>
                <li>
                  <strong class="c-purple"
                    >آیا این طرح از حمایت‌های قبلی ستاد یا سایر نهادها استفاده
                    کرده است؟
                  </strong>

                  {{ proposal.initialIsSupported ? "بله" : "خیر" }}
                </li>

                <li
                  v-if="
                    proposal.initialIsSupported && proposal.initialSupportedType
                  "
                  :class="proposal.initialSupportedType ? 'done' : 'required'"
                >
                  <strong> حمایت ها: </strong
                  >{{
                    options.filter(
                      (x) => x.value == proposal.initialSupportedType
                    )[0].text
                  }}
                </li>
                <li
                  v-if="
                    proposal.initialSupportedType == 'other' &&
                    proposal.initialIsSupported
                  "
                  :class="proposal.initialOtherSupport ? 'done' : 'required'"
                >
                  <strong>عنوان حمایت دریافتی: </strong>
                  {{ proposal.initialOtherSupport }}
                </li>
                <li
                  v-if="proposal.initialIsSupported"
                  :class="
                    proposal.initialSupportDescription ? 'done' : 'required'
                  "
                >
                  <strong>توضیحات حمایت دریافتی: </strong><br />
                  {{ proposal.initialSupportDescription }}
                </li>
              </ul>
            </div>
          </div>
          <hr />
          <div>
            <h2 style="display: inline-block; text-align: center; color: blue">
              اطلاعات اصلی طرح
            </h2>
            <div>
              <ul>
                <li :class="proposal.faSubject ? 'done' : 'required'">
                  <strong>عنوان به زبان فارسی: </strong>{{ proposal.faSubject }}
                </li>
                <li :class="proposal.enSubject ? 'done' : 'required'">
                  <strong>عنوان به زبان انگلیسی: </strong
                  >{{ proposal.enSubject }}
                </li>
                <li :class="proposal.universityId ? 'done' : 'required'">
                  <strong>دانشگاه محل اجرای طرح: </strong>
                  {{
                    proposal.universityId
                      ? universities.filter(
                          (x) => x.id == proposal.universityId
                        )[0]
                        ? universities.filter(
                            (x) => x.id == proposal.universityId
                          )[0].text
                        : ""
                      : ""
                  }}
                </li>
                <li
                  v-if="proposal.universityId == notUniversity"
                  :class="proposal.otherUniversity ? 'done' : 'required'"
                >
                  <strong>نام دانشگاه: </strong>{{ proposal.otherUniversity }}
                </li>
                <li
                  class="mt-4"
                  v-if="proposal.mehvarId != notMehvar"
                  :class="proposal.mehvarId ? 'done' : 'required'"
                >
                  <strong>محور طرح: </strong>
                  {{
                    proposal.mehvarId
                      ? mehvars.filter((x) => x.id == proposal.mehvarId)[0]
                        ? mehvars.filter((x) => x.id == proposal.mehvarId)[0]
                            .text
                        : ""
                      : ""
                  }}
                </li>
                <li
                  v-if="proposal.mehvarId == notMehvar"
                  :class="proposal.mehvarId ? 'done' : 'required'"
                >
                  <strong>محور طرح: </strong> سایر محورها
                </li>
                <li v-if="proposal.mehvarId == notMehvar">
                  <strong>نام محور: </strong>{{ proposal.otherMehvars }}
                </li>
                <li>
                  <strong>ماهیت طرح: </strong>
                  <ul>
                    <li v-if="proposal.typeStudy">مطالعاتی</li>
                    <li v-if="proposal.typeSystemicDevelopmental">
                      سیستمی و توسعه‌ای
                    </li>
                    <li v-if="proposal.typePractical">کاربردی</li>
                  </ul>
                </li>
                <li>
                  <strong>حوزه طرح: </strong>
                  <ul>
                    <li v-if="proposal.zoneMedicine">پزشکی</li>
                    <li v-if="proposal.zoneAgriculture">کشاورزی</li>
                    <li v-if="proposal.zoneEnvironment">محیط زیست</li>
                    <li v-if="proposal.zoneIndustrial">صنعتی</li>
                    <li v-if="proposal.zoneBioComputing">رایانش زیستی</li>
                    <li v-if="proposal.zoneOther">سایر</li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
          <hr />
          <div>
            <h2 style="display: inline-block; text-align: center; color: blue">
              اطلاعات مجری طرح
            </h2>
            <div>
              <ul>
                <li :class="proposal.researcherName ? 'done' : 'required'">
                  <strong>نام: </strong>{{ proposal.researcherName }}
                </li>
                <li :class="proposal.researcherLastName ? 'done' : 'required'">
                  <strong>نام خانوادگی: </strong
                  >{{ proposal.researcherLastName }}
                </li>
                <li :class="proposal.researcherNatCode ? 'done' : 'required'">
                  <strong>کدملی: </strong>{{ proposal.researcherNatCode }}
                </li>
                <li :class="proposal.researcherMobile ? 'done' : 'required'">
                  <strong>تلفن همراه: </strong>{{ proposal.researcherMobile }}
                </li>
                <li :class="proposal.researcherFax ? 'done' : 'required'">
                  <strong>دورنگار: </strong>{{ proposal.researcherFax }}
                </li>
                <li :class="proposal.researcherEmail ? 'done' : 'required'">
                  <strong>پست الکترونیکی: </strong
                  >{{ proposal.researcherEmail }}
                </li>
                <li :class="proposal.researcherState ? 'done' : 'required'">
                  <strong>استان: </strong>{{ proposal.researcherState }}
                </li>
                <li :class="proposal.researcherCity ? 'done' : 'required'">
                  <strong>شهر: </strong>{{ proposal.researcherCity }}
                </li>
                <li
                  :class="proposal.researcherUniversityId ? 'done' : 'required'"
                >
                  <strong>دانشگاه محل تحصیل: </strong>
                  {{
                    proposal.researcherUniversityId
                      ? universities.filter(
                          (x) => x.id == proposal.researcherUniversityId
                        )[0]
                        ? universities.filter(
                            (x) => x.id == proposal.researcherUniversityId
                          )[0].text
                        : "-"
                      : "-"
                  }}
                </li>
                <li
                  :class="
                    proposal.researcherUniversityOther ? 'done' : 'required'
                  "
                  v-if="proposal.researcherUniversityId == notUniversity"
                >
                  <strong>نام دانشگاه: </strong
                  >{{ proposal.researcherUniversityOther }}
                </li>
                <li>
                  <strong>دانشگاه محل اشتغال به عنوان عضوهئیت علمی: </strong>
                  {{
                    proposal.researcherUniversityJobId
                      ? universities.filter(
                          (x) => x.id == proposal.researcherUniversityJobId
                        )[0]
                        ? universities.filter(
                            (x) => x.id == proposal.researcherUniversityJobId
                          )[0].text
                        : "-"
                      : "-"
                  }}
                </li>
                <li v-if="proposal.researcherUniversityJobId == notUniversity">
                  <strong>نام دانشگاه: </strong
                  >{{ proposal.researcherUniversityJobOther }}
                </li>
                <li
                  :class="proposal.researcherLastDegree ? 'done' : 'required'"
                >
                  <strong>آخرین مدرک تحصیلی: </strong
                  >{{ proposal.researcherLastDegree }}
                </li>
                <li :class="proposal.researcherResearch ? 'done' : 'required'">
                  <strong
                    >اهم فعالیت‌های تحقیقاتی پایان یافته و یا در حال اجراء و
                    تألیفات در ارتباط مستقیم با موضوع طرح: </strong
                  ><br />
                  {{ proposal.researcherResearch }}
                </li>
                <li :class="proposal.researcherIndustry ? 'done' : 'required'">
                  <strong
                    >اهم فعالیت‌های صنعتی پایان یافته و یا در حال اجرا در ارتباط
                    مستقیم با موضوع طرح: </strong
                  ><br />
                  {{ proposal.researcherIndustry }}
                </li>
              </ul>
            </div>
          </div>
          <hr />
          <div>
            <h2 style="display: inline-block; text-align: center; color: blue">
              اطلاعات همکاران طرح
            </h2>
            <div>
              <strong>تعداد همکاران طرح: </strong
              >{{ proposal.colleagues.length }}
           
              <div
                v-for="(colleague, index) in proposal.colleagues"
                :key="index"
              >
                <strong style="color: blue">همکار شماره {{ index + 1 }}</strong>
                <ul>
                  <li :class="colleague.name ? 'done' : 'required'">
                    <strong>نام: </strong>{{ colleague.name }}
                  </li>
                  <li :class="colleague.lastName ? 'done' : 'required'">
                    <strong>نام خانوادگی: </strong>{{ colleague.lastName }}
                  </li>
                  <li :class="colleague.natCode ? 'done' : 'required'">
                    <strong>کدملی: </strong>{{ colleague.natCode }}
                  </li>
                  <li :class="colleague.mobile ? 'done' : 'required'">
                    <strong>تلفن همراه: </strong>{{ colleague.mobile }}
                  </li>
                  <li :class="colleague.email ? 'done' : 'required'">
                    <strong>پست الکترونیکی: </strong>{{ colleague.email }}
                  </li>
                  <li :class="colleague.position ? 'done' : 'required'">
                    <strong>سمت: </strong>{{ colleague.position }}
                  </li>
                  <li :class="colleague.universityId ? 'done' : 'required'">
                    <strong>دانشگاه محل تحصیل: </strong>
                    {{
                      colleague.universityId
                        ? universities.filter(
                            (x) => x.id == colleague.universityId
                          )[0]
                          ? universities.filter(
                              (x) => x.id == colleague.universityId
                            )[0].text
                          : "-"
                        : "-"
                    }}
                  </li>
                  <li
                    v-if="colleague.universityId == notUniversity"
                    :class="colleague.universityOther ? 'done' : 'required'"
                  >
                    <strong>نام دانشگاه: </strong
                    >{{ colleague.universityOther }}
                  </li>
                  <li>
                    <strong>دانشگاه محل اشتغال به عنوان عضوهئیت علمی: </strong>
                    {{
                      colleague.universityJobId
                        ? universities.filter(
                            (x) => x.id == colleague.universityJobId
                          )[0]
                          ? universities.filter(
                              (x) => x.id == colleague.universityJobId
                            )[0].text
                          : "-"
                        : "-"
                    }}
                  </li>
                  <li v-if="colleague.universityJobId == notUniversity">
                    <strong>نام دانشگاه: </strong
                    >{{ colleague.universityJobOther }}
                  </li>
                  <li :class="colleague.lastDegree ? 'done' : 'required'">
                    <strong>آخرین مدرک تحصیلی: </strong
                    >{{ colleague.lastDegree }}
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <hr />
          <div>
            <h2 style="display: inline-block; text-align: center; color: blue">
              مشخصات طرح
            </h2>
            <div>
              <ul>
                <li :class="proposal.abstract ? 'done' : 'required'">
                  <strong>چکیده طرح: </strong><br />
                  {{ proposal.abstract }}
                </li>
                <li :class="proposal.requestNecessity ? 'done' : 'required'">
                  <strong>
                    ضرورت اجرای طرح (در جهت دستیابی به اهداف ستاد و یا راهبردها
                    و اقدامات سند توسعه زیست فناوری): </strong
                  ><br />
                  {{ proposal.requestNecessity }}
                </li>
                <li :class="proposal.majorGoals ? 'done' : 'required'">
                  <strong>اهداف کلان طرح: </strong><br />
                  {{ proposal.majorGoals }}
                </li>
                <li :class="proposal.minorGoals ? 'done' : 'required'">
                  <strong>اهداف خرد طرح: </strong><br />
                  {{ proposal.minorGoals }}
                </li>
                <li :class="proposal.benefitsToCountry ? 'done' : 'required'">
                  <strong>مزایای دیگر برای کشور: </strong><br />
                  {{ proposal.benefitsToCountry }}
                </li>
                <li :class="proposal.methodology ? 'done' : 'required'">
                  <strong>روش شناسی (متدولوژی) و مراحل انجام طرح: </strong
                  ><br />
                  {{ proposal.methodology }}
                </li>
                <li
                  :class="
                    proposal.requestProducts.length > 0 ? 'done' : 'required'
                  "
                  v-if="proposal.requestProducts.length > 0"
                >
                  <strong
                    >دستاوردهای عینی و خروجی‌های ملموس(محصول/ محصولات و یا
                    خدمات) حاصل از اجرای طرح:
                  </strong>
                  <!-- NOTE (t-proposal.requestProducts-2) previous -->
                  <b-table
                    responsive
                    small
                    show-empty
                    head-variant="dark"
                    :items="proposal.requestProducts"
                    :fields="achievmentFieldsDoc"
                    empty-text="رکوردی برای نمایش وجود ندارد"
                    class="table table-secondary"
                  >
                    <template v-slot:head()="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.label }}
                      </div>
                    </template>
                    <template v-slot:cell()="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.value }}
                      </div>
                    </template>
                    <template v-slot:cell(index)="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.index + 1 }}
                      </div>
                    </template>
                  </b-table>
                </li>
                <li
                  :class="
                    proposal.executionHistorySimilar ? 'done' : 'required'
                  "
                >
                  <strong
                    >سابقه اجرائی یا طرح‌های مشابه در ایران یا خارج از كشور (با
                    ذكر ماخذ): </strong
                  ><br />
                  {{ proposal.executionHistorySimilar }}
                </li>
                <li
                  :class="proposal.internationalPartners ? 'done' : 'required'"
                >
                  <strong>شركای بین‌المللی در اجرای طرح : </strong><br />
                  {{ proposal.internationalPartners }}
                </li>
                <li :class="proposal.references ? 'done' : 'required'">
                  <strong>منابع و ماخذ: </strong><br />
                  {{ proposal.references }}
                </li>
              </ul>
            </div>
          </div>
          <hr />
          <div>
            <h2 style="display: inline-block; text-align: center; color: blue">
              اطلاعات تجاری‌سازی
            </h2>
            <h4 style="font-size: 18px">
              نوع تجاری‌سازی:
              {{
                proposal.commercializingType == "company"
                  ? "شرکت دانش بنیان"
                  : proposal.commercializingType == "accelerator"
                  ? "شتاب‌دهنده"
                  : "فاقد اطلاعات تجاری‌سازی می‌باشد"
              }}
            </h4>
            <div v-if="proposal.commercializingType == 'company'">
              <ul>
                <div v-if="proposal.companyId != notCompany">
                  <li :class="proposal.companyName ? 'done' : 'required'">
                    <strong>نام شرکت دانش بنیان: </strong
                    >{{ proposal.companyName }}
                  </li>
                  <li
                    :class="
                      proposal.companyRegistrationNumber ? 'done' : 'required'
                    "
                  >
                    <strong>شماره ثبت شرکت: </strong
                    >{{ proposal.companyRegistrationNumber }}
                  </li>
                  <li :class="proposal.companyNationalId ? 'done' : 'required'">
                    <strong>شناسه ملی شرکت: </strong
                    >{{ proposal.companyNationalId }}
                  </li>
                </div>
                <div v-else>
                  <li :class="proposal.companyName ? 'done' : 'required'">
                    <strong>نام شرکت دانش بنیان: </strong
                    >{{ proposal.otherCompanyName }}
                  </li>
                  <li
                    :class="
                      proposal.otherCompanyRegistrationNumber
                        ? 'done'
                        : 'required'
                    "
                  >
                    <strong>شماره ثبت شرکت: </strong
                    >{{ proposal.otherCompanyRegistrationNumber }}
                  </li>
                  <li
                    :class="
                      proposal.otherCompanyNationalId ? 'done' : 'required'
                    "
                  >
                    <strong>شناسه ملی شرکت: </strong
                    >{{ proposal.otherCompanyNationalId }}
                  </li>
                </div>
                <li :class="proposal.companyProducts ? 'done' : 'required'">
                  <strong>معرفی فناوری یا محصولات شرکت: </strong><br />
                  {{ proposal.companyProducts }}
                </li>
                <li :class="proposal.companyContactInfo ? 'done' : 'required'">
                  <strong>آدرس پستی / شماره تماس/ پست الکترونیک شرکت: </strong
                  ><br />
                  {{ proposal.companyContactInfo }}
                </li>
              </ul>
              
            </div>
            <ul v-else-if="proposal.commercializingType == 'accelerator'">
              <li>
                <strong class="c-purple">نام شتاب‌دهنده:</strong>

                {{ proposal.acceleratorName }}
              </li>
            </ul>
            <div v-else-if="proposal.commercializingType == 'none'">
              <ul>
                <li v-if="proposal.commercializingObligation1">
                  تایید میکنم با انتخاب این گزینه تا قبل از تایید درخواست توسط
                  یکی از شتاب‌دهنده‌ها یا شرکت‌های مجاز، ستاد توسعه زیست فناوری
                  هیچگونه مسئولیتی در قبال درخواست من نخواهد داشت.
                </li>
                <li v-if="proposal.commercializingObligation2">
                  تایید میکنم با انتخاب این گزینه، کلیه اطلاعات شخصی و علمی این
                  درخواست، در اختیار شتاب‌دهنده‌ها و شرکت‌های مجاز قرار خواهد
                  گرفت تا بتوانند با بررسی اطلاعات، درخواست بنده را بررسی و
                  تایید کنند.
                </li>
              </ul>
            </div>
            <h4 style="color: blue" class="mt-3">
                <strong
                  >ملاحظات مربوط به همکاری طرفین، بازار و عایدی طرح </strong
                ><br />
              </h4>
              <ul>
                <li
                  :class="
                    proposal.interactUniversityCenters ? 'done' : 'required'
                  "
                >
                  <strong
                    >نحوه تعامل با دانشگاه یا مراکز و ملاحظات مربوط به حق
                    مالکیت: </strong
                  ><br />
                  {{ proposal.interactUniversityCenters }}
                </li>
                <li :class="proposal.targetMarket ? 'done' : 'required'">
                  <strong>معرفی بازار هدف: </strong><br />
                  {{ proposal.targetMarket }}
                </li>
                <li
                  :class="proposal.productSalesForecast ? 'done' : 'required'"
                >
                  <strong>پیش بینی میزان فروش محصول در سه سال اول: </strong
                  ><br />
                  {{ proposal.productSalesForecast }}
                </li>
                <li :class="proposal.employment ? 'done' : 'required'">
                  <strong>میزان اشتغال زایی طرح: </strong><br />
                  {{ proposal.employment }}
                </li>
                <li :class="proposal.durationCooperation ? 'done' : 'required'">
                  <strong>برآورد مدت زمان همکاری: </strong><br />{{
                    proposal.durationCooperation
                  }}
                </li>
                <li
                  :class="
                    proposal.estimationProductionProjectRevenue
                      ? 'done'
                      : 'required'
                  "
                >
                  <strong>برآورد میزان تولید و عایدی طرح: </strong><br />{{
                    proposal.estimationProductionProjectRevenue
                  }}
                </li>
                <li
                  :class="
                    proposal.competitiveProductsLevelCompetitiveness
                      ? 'done'
                      : 'required'
                  "
                >
                  <strong
                    >محصولات رقیب و میزان رقابت پذیری(مقایسه قیمت) (در صورت
                    وجود): </strong
                  ><br />
                  {{ proposal.competitiveProductsLevelCompetitiveness }}
                </li>
                <li :class="proposal.productAdvantages ? 'done' : 'required'">
                  <strong>مزیت محصول نسبت به موارد مشابه و موجود: </strong
                  ><br />
                  {{ proposal.productAdvantages }}
                </li>
              </ul>
          </div>
          <hr />
          <div>
            <h2 style="display: inline-block; text-align: center; color: blue">
              زمان بندی طرح
            </h2>
            <div>
              <strong>زمان شروع: </strong>
              {{
                proposal.gantData.length > 0
                  ? moment(
                      new Date(
                        Math.min(
                          ...proposal.gantData.map((x) =>
                            new Date(
                              moment(x.startDate, "jYYYY/jMM/jDD").format(
                                "YYYY-MM-DD"
                              )
                            ).getTime()
                          )
                        )
                      )
                    ).format("jDD/jMM/jYYYY")
                  : ""
              }}
              <br />
              <strong>زمان پایان: </strong>
              {{
                proposal.gantData.length > 0
                  ? moment(
                      new Date(
                        Math.max(
                          ...proposal.gantData.map((x) =>
                            new Date(
                              moment(x.dueDate, "jYYYY/jMM/jDD").format(
                                "YYYY-MM-DD"
                              )
                            ).getTime()
                          )
                        )
                      )
                    ).format("jDD/jMM/jYYYY")
                  : ""
              }}
              <br />
              <strong>مدت زمان: </strong>
              {{
                proposal.gantData.length > 0
                  ? (Math.max(
                      ...proposal.gantData.map((x) =>
                        new Date(
                          moment(x.dueDate, "jYYYY/jMM/jDD").format(
                            "YYYY-MM-DD"
                          )
                        ).getTime()
                      )
                    ) -
                      Math.min(
                        ...proposal.gantData.map((x) =>
                          new Date(
                            moment(x.startDate, "jYYYY/jMM/jDD").format(
                              "YYYY-MM-DD"
                            )
                          ).getTime()
                        )
                      )) /
                      3600 /
                      24 /
                      1000 +
                    " روز"
                  : ""
              }}
              <br />
            </div>
            <b-table
              responsive
              small
              show-empty
              head-variant="dark"
              :items="proposal.gantData"
              :fields="serviceFieldsDoc"
              empty-text="رکوردی برای نمایش وجود ندارد"
              class="table table-secondary"
            >
              <template v-slot:head()="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.label }}
                </div>
              </template>
              <template v-slot:cell()="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.value }}
                </div>
              </template>
              <template v-slot:cell(index)="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.index + 1 }}
                </div>
              </template>
            </b-table>
          </div>
          <hr />
          <div>
            <h2 style="display: inline-block; text-align: center; color: blue">
              هزینه‌ها
            </h2>
            <div>
              <div v-if="proposal.personnelCosts.length > 0">
                <h4 style="color: blue">
                  هزینه‌های پرسنلی اعم از مجری و همكاران
                </h4>

                <!-- NOTE (t-personnelCost2) previous -->
                <b-table
                  responsive
                  small
                  show-empty
                  head-variant="dark"
                  :items="proposal.personnelCosts"
                  :fields="PersonnelCostFieldDoc"
                  empty-text="رکوردی برای نمایش وجود ندارد"
                  class="table table-secondary mb-4"
                >
                  <template v-slot:head()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.label }}
                    </div>
                  </template>
                  <template v-slot:cell()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.value }}
                    </div>
                  </template>
                  <template v-slot:cell(index)="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.index + 1 }}
                    </div>
                  </template>
                  <template v-slot:cell(humanResourceCost)="data">
                    <div>
                      {{
                        (
                          parseInt(data.item.perPersonCost) *
                          parseInt(data.item.cooperationHour)
                        ).toLocaleString()
                      }}
                    </div>
                  </template>
                </b-table>
                <!-- {{proposal.personnelCosts.map(x=>x.humanResourceCost).reduce((a,b)=>(parseInt(a)+parseInt(b)))}} -->
                <p>
                  <strong>جمع کل هزینه های پرسنلی: </strong>
                  {{
                    proposal.personnelCosts.length == 0
                      ? 0
                      : proposal.personnelCosts
                          .map(
                            (x) =>
                              parseInt(x.perPersonCost) *
                              parseInt(x.cooperationHour)
                          )
                          .reduce((a, b) => parseInt(a) + parseInt(b), 0)
                          .toLocaleString()
                  }}
                  تومان
                </p>
              </div>

              <div v-if="proposal.travelExpenses.length > 0">
                <h4 style="color: blue">
                  هزینه مسافرت‌های ضروری (اعم از هزینه بلیط، اسكان، غذا، حمل و
                  نقل، حق مأموریت و ...):
                </h4>

                <!-- NOTE (t-tripCost2) previous -->
                <b-table
                  responsive
                  small
                  show-empty
                  head-variant="dark"
                  :items="proposal.travelExpenses"
                  :fields="tripCostFieldDoc"
                  empty-text="رکوردی برای نمایش وجود ندارد"
                  class="table table-secondary mb-4"
                >
                  <template v-slot:head()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.label }}
                    </div>
                  </template>
                  <template v-slot:cell()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.value }}
                    </div>
                  </template>
                  <template v-slot:cell(index)="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.index + 1 }}
                    </div>
                  </template>
                </b-table>
                <strong>جمع کل مسافرتهای ضروری: </strong>
                {{
                  proposal.travelExpenses.length == 0
                    ? 0
                    : proposal.travelExpenses
                        .map((x) => x.cost)
                        .reduce((a, b) => parseInt(a) + parseInt(b), 0)
                        .toLocaleString()
                }}
                تومان
              </div>
              <div v-if="proposal.purchases.length > 0">
                <h4 class="mt-5 mb-3" style="color: blue">
                  هزینه دستگاه‌ها، وسایل و مواد مورد نیازكه باید از محل اعتبار
                  طرح خریداری شوند:
                </h4>

                <!-- NOTE (t-deviceCost2) previous -->
                <b-table
                  responsive
                  small
                  show-empty
                  head-variant="dark"
                  :items="proposal.purchases"
                  :fields="deviceCostFieldDoc"
                  empty-text="رکوردی برای نمایش وجود ندارد"
                  class="table table-secondary"
                >
                  <template v-slot:head()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.label }}
                    </div>
                  </template>
                  <template v-slot:cell()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.value }}
                    </div>
                  </template>
                  <template v-slot:cell(index)="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.index + 1 }}
                    </div>
                  </template>
                  <template v-slot:cell(totalPrice)="data">
                    <div>
                      {{
                        (
                          parseInt(data.item.number) *
                          parseInt(data.item.perPrice)
                        ).toLocaleString()
                      }}
                    </div>
                  </template>
                </b-table>
                <strong>جمع کل هزینه دستگاه‌ها: </strong>
                {{
                  proposal.purchases.length == 0
                    ? 0
                    : proposal.purchases
                        .map((x) => parseInt(x.perPrice) * parseInt(x.number))
                        .reduce((a, b) => parseInt(a) + parseInt(b), 0)
                        .toLocaleString()
                }}
                تومان
              </div>

              <div v-if="proposal.participationOrganizationBudget.length > 0">
                <h4 class="mt-5 mb-3" style="color: blue">
                  میزان مشارکت سایر موسسات:
                </h4>

                <!-- NOTE (t-orgCost2) previous -->
                <b-table
                  responsive
                  small
                  show-empty
                  head-variant="dark"
                  :items="proposal.participationOrganizationBudget"
                  :fields="OrgCostFieldDoc"
                  empty-text="رکوردی برای نمایش وجود ندارد"
                  class="table table-secondary"
                >
                  <template v-slot:head()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.label }}
                    </div>
                  </template>
                  <template v-slot:cell()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.value }}
                    </div>
                  </template>
                  <template v-slot:cell(index)="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.index + 1 }}
                    </div>
                  </template>
                </b-table>
                <strong>جمع کل مشارکت موسسات: </strong>
                {{
                  proposal.participationOrganizationBudget.length == 0
                    ? 0
                    : proposal.participationOrganizationBudget
                        .map((x) => x.totalPrice)
                        .reduce((a, b) => parseInt(a) + parseInt(b), 0)
                        .toLocaleString()
                }}
                تومان
              </div>
              <div
                v-show="
                  proposal.otherCosts
                    .map((x) => x.totalPrice)
                    .reduce((a, b) => parseInt(a) + parseInt(b), 0) > 0
                "
              >
                <h4 style="color: blue">هزینه‌های دیگر:</h4>

                <!-- NOTE (t-otherCost2) previous -->
                <b-table
                  responsive
                  small
                  show-empty
                  head-variant="dark"
                  :items="proposal.otherCosts"
                  :fields="otherCostFieldDoc"
                  empty-text="رکوردی برای نمایش وجود ندارد"
                  class="table table-secondary"
                >
                  <template v-slot:head()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.label }}
                    </div>
                  </template>
                  <template v-slot:cell()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.value }}
                    </div>
                  </template>
                  <template v-slot:cell(index)="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.index + 1 }}
                    </div>
                  </template>
                </b-table>
                <p>
                  <strong>جمع کل سایر هزینه‌ها: </strong>
                  {{
                    proposal.otherCosts.length == 0
                      ? 0
                      : proposal.otherCosts
                          .map((x) => x.totalPrice)
                          .reduce((a, b) => parseInt(a) + parseInt(b), 0)
                          .toLocaleString()
                  }}
                  تومان
                </p>
              </div>
              <h3>
                <strong>جمع کل هزینه‌ها: </strong>
                {{
                  (tPrice = (
                    (proposal.personnelCosts.length == 0
                      ? 0
                      : proposal.personnelCosts
                          .map(
                            (x) =>
                              parseInt(x.perPersonCost) *
                              parseInt(x.cooperationHour)
                          )
                          .reduce((a, b) => parseInt(a) + parseInt(b), 0)) +
                    (proposal.travelExpenses.length == 0
                      ? 0
                      : proposal.travelExpenses
                          .map((x) => x.cost)
                          .reduce((a, b) => parseInt(a) + parseInt(b), 0)) +
                    (proposal.purchases.length == 0
                      ? 0
                      : proposal.purchases
                          .map((x) => parseInt(x.perPrice) * parseInt(x.number))
                          .reduce((a, b) => parseInt(a) + parseInt(b), 0)) +
                    (proposal.otherCosts.length == 0
                      ? 0
                      : proposal.otherCosts
                          .map((x) => x.totalPrice)
                          .reduce((a, b) => parseInt(a) + parseInt(b), 0))
                  ).toLocaleString())
                }}
                تومان
              </h3>
              <h4>
                <strong>میزان اعتبار مورد نیاز از ستاد زیست فناوری: </strong>
                {{ computedTotalCost.toLocaleString() }}
                تومان
              </h4>
            </div>
          </div>
          <hr />
          <div>
            <h2 style="display: inline-block; text-align: center; color: blue">
              اطلاعات داوران پیشنهادی
            </h2>
            <div>
              <strong>تعداد داوران طرح: </strong>{{ proposal.reviewers.length }}
              <div
                style="margin-bottom: 5px"
                v-for="(reviewer, index) in proposal.reviewers"
                :key="index"
              >
                <p style="color: blue">
                  <strong>داور شماره {{ index + 1 }}</strong>
                </p>
                <ul>
                  <li :class="reviewer.name ? 'done' : 'required'">
                    <strong>نام: </strong>{{ reviewer.name }}
                  </li>
                  <li :class="reviewer.lastName ? 'done' : 'required'">
                    <strong>نام خانوادگی: </strong>{{ reviewer.lastName }}
                  </li>
                  <li :class="reviewer.expertise ? 'done' : 'required'">
                    <strong>حوزه کاری: </strong>{{ reviewer.expertise }}
                  </li>
                  <li :class="reviewer.field ? 'done' : 'required'">
                    <strong>رشته تحصیلی: </strong>{{ reviewer.field }}
                  </li>
                  <li :class="reviewer.lastDegree ? 'done' : 'required'">
                    <strong>آخرین مدرک تحصیلی: </strong
                    >{{ reviewer.lastDegree }}
                  </li>
                  <li :class="reviewer.academicRank ? 'done' : 'required'">
                    <strong>رتبه علمی: </strong>{{ reviewer.academicRank }}
                  </li>
                  <li :class="reviewer.email ? 'done' : 'required'">
                    <strong>پست الکترونیکی: </strong>{{ reviewer.email }}
                  </li>
                  <li :class="reviewer.mobile ? 'done' : 'required'">
                    <strong>شماره تماس: </strong>{{ reviewer.mobile }}
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <hr />
          <div>
            <h2 style="display: inline-block; text-align: center; color: blue">
              تعهدات
            </h2>
            <div>
              <ul>
                <li v-if="proposal.promiseArrays[0]">
                  این طرح در مدت زمان اعلام شده در پروپوزال انجام می‌گردد و
                  مسئولیت تاخیر در انجام طرح بر عهده مجری می‌باشد. مدت زمان:
                  {{
                    proposal.gantData.length > 0
                      ? (Math.max(
                          ...proposal.gantData.map((x) =>
                            new Date(
                              moment(x.dueDate, "jYYYY/jMM/jDD").format(
                                "YYYY-MM-DD"
                              )
                            ).getTime()
                          )
                        ) -
                          Math.min(
                            ...proposal.gantData.map((x) =>
                              new Date(
                                moment(x.startDate, "jYYYY/jMM/jDD").format(
                                  "YYYY-MM-DD"
                                )
                              ).getTime()
                            )
                          )) /
                          3600 /
                          24 /
                          1000 +
                        " روز"
                      : ""
                  }}
                </li>
                <li v-if="proposal.promiseArrays[1]">
                  این طرح با بودجه اعلام شده در پروپوزال انجام می‌گردد. هزینه
                  انجام:
                  {{
                    (
                      parseInt(
                        proposal.personnelCosts.length == 0
                          ? 0
                          : proposal.personnelCosts
                              .map(
                                (x) =>
                                  parseInt(x.perPersonCost) *
                                  parseInt(x.cooperationHour)
                              )
                              .reduce((a, b) => parseInt(a) + parseInt(b), 0)
                      ) +
                      parseInt(
                        proposal.travelExpenses.length == 0
                          ? 0
                          : proposal.travelExpenses
                              .map((x) => x.cost)
                              .reduce((a, b) => parseInt(a) + parseInt(b), 0)
                      ) +
                      parseInt(
                        proposal.otherCosts.length == 0
                          ? 0
                          : proposal.otherCosts
                              .map((x) => x.totalPrice)
                              .reduce((a, b) => parseInt(a) + parseInt(b), 0)
                      ) +
                      parseInt(
                        proposal.purchases.length == 0
                          ? 0
                          : proposal.purchases
                              .map(
                                (x) => parseInt(x.perPrice) * parseInt(x.number)
                              )
                              .reduce((a, b) => parseInt(a) + parseInt(b), 0)
                      )
                    ).toLocaleString()
                  }}
                  تومان
                </li>
                <li v-if="proposal.promiseArrays[2]">
                  کلیه حقوق مادی و معنوی این طرح متعلق به ستاد زیست فناوری
                  می‌باشد.
                </li>
                <li v-if="proposal.promiseArrays[3]">
                  توافق بین دانشگاه و صنعت در خصوص دستاوردهای طرح وجود دارد.
                </li>
                <li v-if="proposal.promiseArrays[4]">
                  نحوه و مسیر تجاری سازی طرح مشخص است و مستندات ارائه شده است.
                </li>
                <li v-if="proposal.promiseArrays[5]">
                  بهره‌بردار نهایی طرح مشخص است و مستندات ارائه شده است. نام
                  بهره‌بردار:
                  {{
                    proposal.researcherName + " " + proposal.researcherLastName
                  }}
                </li>
                <li v-if="proposal.promiseArrays[6]">
                  حداقل 1 مقاله ISI معتبر به عنوان خروجی طرح تعهد می‌شود.
                </li>
                <li v-if="proposal.promiseArrays[7]">
                  تمامی گزارش‌ها پیشرفت در موعد مقرر مطابق با گانت چارت انجام
                  خواهد شد.
                </li>
                <li v-if="proposal.promiseArrays[8]">
                  کلیه گزارش‌ها و خروجی‌ها و دستاوردهای طرح در پایان انجام طرح
                  به ستاد زیست فناوری ارسال و تحویل داده می‌شود.
                </li>
                <li v-if="proposal.promiseArrays[9]">
                  کلیه اصلاحات در مورد مقرر و طی 2 هفته توسط مجری انجام و در
                  سایت بارگذاری می‌گردد.
                </li>
                <li v-if="proposal.promiseArrays[10]">
                  ثبت اطلاعات در سامانه هیچ تعهدی را برای ستاد ایجاد نمی‌کند و
                  به منزله ثبت درخواست متقاضی است.
                </li>
                <li v-if="proposal.promiseArrays[11]">
                  کلیه موارد فوق مورد تایید اینجانب
                  {{
                    proposal.researcherName + " " + proposal.researcherLastName
                  }}
                  به عنوان مجری طرح و همکاران می‌باشد.
                </li>
              </ul>
            </div>
          </div>
          <hr />
        </div>
      </div>
      <!-- docx -->
      <b-tabs pills v-model="tabIndex" class="mt-8">
        <b-tab title="چکیده طرح" lazy>
          <Proposal
            :proposal="proposal"
            :universities="universities"
            :mehvars="mehvars"
            :companies="companies"
            :isLoaded="isLoaded"
          />
        </b-tab>
        <b-tab title="اطلاعات تجاری‌سازی">
          <v-row class="px-4">
            <v-col md="6" cols="12">
              <h4 class="c-dark mt-2">
                نوع تجاری‌سازی:
                {{
                  proposal.commercializingType == "company"
                    ? "شرکت دانش بنیان"
                    : proposal.commercializingType == "accelerator"
                    ? "شتاب‌دهنده"
                    : "فاقد اطلاعات تجاری‌سازی می‌باشد"
                }}
              </h4>
            </v-col>
          </v-row>
          <b-card-body>
            <div v-if="proposal.commercializingType == 'company'">
              <ul>
                <div v-if="proposal.companyId != notCompany">
                  <li>
                    <strong class="c-purple">نام شرکت دانش بنیان:</strong>

                    {{ proposal.companyName }}
                  </li>
                  <li>
                    <strong class="c-purple">شماره ثبت شرکت:</strong>

                    {{ proposal.companyRegistrationNumber }}
                  </li>
                  <li>
                    <strong class="c-purple">شناسه ملی شرکت:</strong>

                    {{ proposal.companyNationalId }}
                  </li>
                </div>
                <div v-else>
                  <li>
                    <strong class="c-purple">نام شرکت دانش بنیان:</strong>

                    {{ proposal.otherCompanyName }}
                  </li>
                  <li>
                    <strong class="c-purple">شماره ثبت شرکت:</strong>

                    {{ proposal.otherCompanyRegistrationNumber }}
                  </li>
                  <li>
                    <strong class="c-purple">شناسه ملی شرکت:</strong>

                    {{ proposal.otherCompanyNationalId }}
                  </li>
                </div>
                <li>
                  <strong class="c-purple"
                    >معرفی فناوری یا محصولات شرکت:</strong
                  >

                  {{ proposal.companyProducts }}
                </li>
                <li>
                  <strong class="c-purple"
                    >آدرس پستی / شماره تماس/ پست الکترونیک شرکت:</strong
                  >

                  {{ proposal.companyContactInfo }}
                </li>
              </ul>

            
            </div>
            <ul v-else-if="proposal.commercializingType == 'accelerator'" class="ps-2">
              <li>
                <strong class="c-purple">نام شتاب‌دهنده:</strong>

                {{ proposal.acceleratorName }}
              </li>
            </ul>
            <div v-else-if="proposal.commercializingType == 'none'">
              <div class="d-flex flex-row mb-2">
                <b-form-checkbox
                  readonly
                  v-model="proposal.commercializingObligation1"
                  @change="reactivity = !reactivity"
                ></b-form-checkbox
                ><span class="ps-2">
                  تایید میکنم با انتخاب این گزینه تا قبل از تایید درخواست توسط
                  یکی از شتاب‌دهنده‌ها یا شرکت‌های مجاز، ستاد توسعه زیست فناوری
                  هیچگونه مسئولیتی در قبال درخواست من نخواهد داشت.
                </span>
              </div>
              <div class="d-flex flex-row mb-2">
                <b-form-checkbox
                  readonly
                  v-model="proposal.commercializingObligation2"
                  @change="reactivity = !reactivity"
                ></b-form-checkbox>
                <span class="ps-2">
                  تایید میکنم با انتخاب این گزینه، کلیه اطلاعات شخصی و علمی این
                  درخواست، در اختیار شتاب‌دهنده‌ها و شرکت‌های مجاز قرار خواهد
                  گرفت تا بتوانند با بررسی اطلاعات، درخواست بنده را بررسی و
                  تایید کنند.
                </span>
              </div>
            </div>
            <hr>
              <h5 class="c-dark mt-3">
                ملاحظات مربوط به همکاری طرفین، بازار و عایدی طرح
              </h5>
              <ul class="ps-2">
                <li>
                  <strong class="c-purple">معرفی بازار هدف:</strong>

                  {{ proposal.targetMarket }}
                </li>
                <li>
                  <strong class="c-purple">
                    نحوه تعامل با دانشگاه یا مراکز و ملاحظات مربوط به حق مالکیت:
                  </strong>
                  {{ proposal.interactUniversityCenters }}
                </li>
                <li>
                  <strong class="c-purple"
                    >پیش بینی میزان فروش محصول در سه سال اول:</strong
                  >

                  {{ proposal.productSalesForecast }}
                </li>
                <li>
                  <strong class="c-purple">میزان اشتغال زایی طرح:</strong>

                  {{ proposal.employment }}
                </li>
                <li>
                  <strong class="c-purple">برآورد مدت زمان همکاری:</strong>

                  {{ proposal.durationCooperation }}
                </li>
                <li>
                  <strong class="c-purple"
                    >برآورد میزان تولید و عایدی طرح:</strong
                  >

                  {{ proposal.estimationProductionProjectRevenue }}
                </li>
                <li>
                  <strong class="c-purple"
                    >محصولات رقیب و میزان رقابت پذیری (مقایسه قیمت):</strong
                  >

                  {{ proposal.competitiveProductsLevelCompetitiveness }}
                </li>
                <li>
                  <strong class="c-purple"
                    >مزیت محصول نسبت به موارد مشابه و موجود:</strong
                  >

                  {{ proposal.productAdvantages }}
                </li>
              </ul>
          </b-card-body>
        </b-tab>
        <b-tab title="فایل های تکمیلی">
          <Files :files="proposal.uploadedFiles" :isLoaded="isLoaded" />
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>

<script>
import moment from "moment-jalaali"; // NOTE (IMPORT) to convert dates to each other
import Proposal from "./../../components/AcceleratorProposal";
import Files from "./../../components/UploadedFiles";
import VuePersianDatetimePicker from "vue-persian-datetime-picker"; // NOTE (IMPORT) date selection
import { MultiSelect } from "vue-search-select";
const sarmadGantt = () => import("./../../components/sarmadGantt");
import Select2 from "v-select2-component";
export default {
  components: {
    datePicker: VuePersianDatetimePicker,
    sarmadGantt, // NOTE (COMPONENT) component of sarmad gantt chart
    Select2, // NOTE (COMPONENT) component of select2 plugin
    MultiSelect,
    Proposal,
    Files,
  },
  data() {
    return {
      moment: moment,
      isLoaded: false,
      review: {
        isRequestApproved: null,
      },
      tabIndex: 0,
      proposal: {},
      exportDate: moment(new Date()).format("jDD/jMM/jYYYY"),
      options: [
        { text: "طرح", value: "project" },
        { text: "پایان‌نامه ارشد", value: "master" },
        { text: "رساله دکتری", value: "phd" },
        { text: "مقالات", value: "article" },
        { text: "نشست‌ها", value: "meeting" },
        { text: "دوره‌های پسادکتری", value: "postDoc" },
        { text: "فرصت‌های مطالعاتی", value: "opportune" },
        { text: "نخبگان وظیفه", value: "elite" },
        { text: "سایر", value: "other" },
      ],
      fileFields: [
        { key: "index", label: "ردیف" },
        { key: "showName", label: "نام فایل" },
        // { key: "title", label: "عنوان فایل" },
        // { key: "description", label: "توضیحات" },
        { key: "url", label: "دریافت" },
      ],
      fileItems: [],
      fileFilter: "",

      acc: 0,
      achievmentFields: [
        { key: "index", label: "#" },
        { key: "name", label: "نام دستاورد و خروجی" },
        { key: "amount", label: "کمی شده دستاورد و خروجی" },
        { key: "fullfill", label: "پیش بینی زمان تحقق دستاورد و خروجی" },
        { key: "operation", label: "" },
      ],
      achievmentFieldsDoc: [
        { key: "index", label: "#" },
        { key: "name", label: "نام دستاورد و خروجی" },
        { key: "amount", label: "کمی شده دستاورد و خروجی" },
        { key: "fullfill", label: "پیش بینی زمان تحقق دستاورد و خروجی" },
      ],
      serviceItems: [],
      serviceFields: [
        { key: "index", label: "#" },
        { key: "description", label: "شرح فعالیت‌ها" },
        { key: "percent", label: "درصد وزنی فعالیت " },
        { key: "startDate", label: "تاریخ شروع" },
        { key: "dueDate", label: "تاریخ پایان" },
        { key: "cellColor", label: "رنگ" },
        { key: "operation", label: "" },
      ],
      serviceFieldsDoc: [
        { key: "index", label: "#" },
        { key: "description", label: "شرح فعالیت‌ها" },
        { key: "percent", label: "درصد وزنی فعالیت " },
        { key: "startDate", label: "تاریخ شروع" },
        { key: "dueDate", label: "تاریخ پایان" },
      ],
      PersonnelCostField: [
        { key: "index", label: "#" },
        { key: "name", label: "نام و نام خانوادگی" },
        { key: "degree", label: "میزان تحصیلات" },
        { key: "cooperationType", label: "نوع همکاری" },
        { key: "cooperationHour", label: "هزینه نفر ساعت(تومان)" },
        { key: "perPersonCost", label: " هزینه نفر ساعت" },
        {
          key: "humanResourceCost",
          label: "هزینه نیروی انسانی (تومان)",
        },
        { key: "operation", label: "" },
      ],
      PersonnelCostFieldDoc: [
        { key: "index", label: "#" },
        { key: "name", label: "نام و نام خانوادگی" },
        { key: "degree", label: "میزان تحصیلات" },
        { key: "cooperationType", label: "نوع همکاری" },
        { key: "cooperationHour", label: "هزینه نفر ساعت(تومان)" },
        { key: "perPersonCost", label: " هزینه نفر ساعت" },
        {
          key: "humanResourceCost",
          label: "هزینه نیروی انسانی (تومان)",
        },
      ],
      tripCostField: [
        { key: "index", label: "#" },
        { key: "destination", label: "مقصد" },
        { key: "reason", label: "منظور از مسافرت" },
        { key: "number", label: "تعداد افراد" },
        // { key: "day", label: "نفر روز" },
        { key: "cost", label: "هزینه کل سفر" },
        { key: "operation", label: "" },
      ],
      tripCostFieldDoc: [
        { key: "index", label: "#" },
        { key: "destination", label: "مقصد" },
        { key: "reason", label: "منظور از مسافرت" },
        { key: "number", label: "تعداد افراد" },
        // { key: "day", label: "نفر روز" },
        { key: "cost", label: "هزینه کل سفر" },
      ],
      deviceCostField: [
        { key: "index", label: "#" },
        { key: "name", label: "نام دستگاه" },
        // { key: "consumable", label: "مصرفی" },
        // { key: "fund", label: "سرمایه‌ای" },
        { key: "type", label: "نوع" },
        { key: "source", label: "محل تامین", cssClass: "table-column" },
        { key: "number", label: "تعداد/میزان" },
        { key: "perPrice", label: "قیمت واحد به تومان" },
        { key: "totalPrice", label: "قیمت کل به تومان" },
        { key: "operation", label: "" },
      ],
      deviceCostFieldDoc: [
        { key: "index", label: "#" },
        { key: "name", label: "نام دستگاه" },
        // { key: "consumable", label: "مصرفی" },
        // { key: "fund", label: "سرمایه‌ای" },
        { key: "type", label: "نوع" },
        { key: "source", label: "محل تامین", cssClass: "table-column" },
        { key: "number", label: "تعداد/میزان" },
        { key: "perPrice", label: "قیمت واحد به تومان" },
        { key: "totalPrice", label: "قیمت کل به تومان" },
      ],
      OrgCostItem: [],
      rejectMessage: "",
      OrgCostField: [
        { key: "index", label: "#" },
        { key: "name", label: "نام موسسه" },
        {
          key: "description",
          label: "نوع همكاری (شرح وظایف به طور دقیق و شفاف مشخص شود)",
        },
        { key: "totalPrice", label: "میزان مشارکت (تومان)" },
        { key: "operation", label: "" },
      ],
      OrgCostFieldDoc: [
        { key: "index", label: "#" },
        { key: "name", label: "نام موسسه" },
        {
          key: "description",
          label: "نوع همكاری (شرح وظایف به طور دقیق و شفاف مشخص شود)",
        },
        { key: "totalPrice", label: "میزان مشارکت (تومان)" },
      ],
      otherCostField: [
        { key: "index", label: "#" },
        { key: "name", label: "نوع هزینه‌ها" },
        { key: "totalPrice", label: "مبلغ" },
      ],
      otherCostFieldDoc: [
        { key: "index", label: "#" },
        { key: "name", label: "نوع هزینه‌ها" },
        { key: "totalPrice", label: "مبلغ" },
      ],
      universities: [],
      mehvars: [],
      companies: [],
      uploadedFiles: [],
    };
  },

  methods: {
    getInfo() {
      this.isLoaded = false;
      let acc = 0;
      //universities
      this.$http
        .post(
          this.baseUrl + "/setad/options/universities",
          {},
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.universities = res.data;
          this.universities.push(
            new Object({
              id: this.notUniversity,
              text: "سایر دانشگاه ها",
            })
          );
          this.universities.unshift({
            id: 0,
            text: "--گزینه مورد نظر خود را انتخاب نمایید--",
            disabled: "true",
          });

          acc++;

          if (acc > 2) {
            try {
              document.body.classList.toggle("sidebar-minimized");
              document.body.classList.toggle("brand-minimized");

              this.toast(
                "در صورت نیاز به منو، میتوانید از علامت موجود در سمت راست صفحه استفاده کنید"
              );
            } catch {}
            this.$bvModal.hide("loading");
            this.isLoaded = true;
          }
        })
        .catch((err) => {
          console.log(err)
        });
      /////////////////////////////////////////////
      // mehvars
      this.$http
        .post(
          this.baseUrl + "/setad/options/uniMehvars",
          {},
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.mehvars = res.data;
          acc++;

          if (acc > 2) {
            try {
              document.body.classList.toggle("sidebar-minimized");
              document.body.classList.toggle("brand-minimized");
              this.toast(
                "در صورت نیاز به منو، میتوانید از علامت موجود در سمت راست صفحه استفاده کنید"
              );
            } catch {}
            this.$bvModal.hide("loading");
            this.isLoaded = true;
          }
        })
        .catch((err) => {
          console.log(err)
        });
      /////////////////////////////////////////////
      // companies
      this.$http
        .post(
          this.baseUrl + "/setad/options/companies",
          {},
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.companies = res.data;
          this.companies.forEach((x) => {
            x.text = x.name;
          });
          this.companies.push(
            new Object({
              id: this.notCompany,
              text: "سایر شرکت ها",
            })
          );
          acc++;

          if (acc > 2) {
            try {
              document.body.classList.toggle("sidebar-minimized");
              document.body.classList.toggle("brand-minimized");
              this.toast(
                "در صورت نیاز به منو، میتوانید از علامت موجود در سمت راست صفحه استفاده کنید"
              );
            } catch {}
            this.$bvModal.hide("loading");
            this.isLoaded = true;
          }
        })
        .catch((err) => {
          console.log(err)
        });
      //////////////////////////////////////
      // getInfo  
      this.$http
        .post(
          this.baseUrl + "/setad/accelerator/request/project/getInfo",
          {
            requestId: this.$route.params.id,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.proposal = res.data;
          //this.files = res.data.uploadedFiles;
          // this.pageLoaded = true;
          acc++;
          if (acc > 2) {
            try {
              document.body.classList.toggle("sidebar-minimized");
              document.body.classList.toggle("brand-minimized");
              this.toast(
                "در صورت نیاز به منو، میتوانید از علامت موجود در سمت راست صفحه استفاده کنید"
              );
            } catch {}
            this.$bvModal.hide("loading");
            this.isLoaded = true;
          }
          setTimeout(() => {
            this.isLoaded = true;
          }, 200);

        })
        .catch((err) => {
          this.notLoaded = true;
          console.log(err)
        });
    },
    saveDocx(element) {
      var preHtml =
        "<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:w='urn:schemas-microsoft-com:office:word' xmlns='http://www.w3.org/TR/REC-html40'><head><meta charset='utf-8'><title>sarmad</title><style>.done{color: black} .required{color:red} strong{font-family:B Titr;} table, td, th {border: 1px solid black} table {width:100%; border-collapse: collapse} .all{direction : rtl; text-align: right} body{font-family:B Nazanin;}</style></body></body></head><body>";
      var postHtml = "</body></html>";
      var html =
        preHtml + document.getElementById(element).innerHTML + postHtml;

      var blob = new Blob(["\ufeff", html], {
        type: "application/msword",
      });

      // Specify link url
      var url =
        "data:application/vnd.ms-word;charset=utf-8," +
        encodeURIComponent(html);

      // Specify file name
      let filename = this.proposal.requestsCode + ".doc";

      // Create download link element
      var downloadLink = document.createElement("a");

      document.body.appendChild(downloadLink);

      if (navigator.msSaveOrOpenBlob) {
        navigator.msSaveOrOpenBlob(blob, filename);
      } else {
        // Create a link to the file
        downloadLink.href = url;

        // Setting the file name
        downloadLink.download = filename;

        //triggering the function
        downloadLink.click();
      }

      document.body.removeChild(downloadLink);
    },
  },

  computed: {
    computedTotalCost() {
      let tempPrice =
        (this.proposal.personnelCosts.length == 0
          ? 0
          : this.proposal.personnelCosts
              .map(
                (x) => parseInt(x.perPersonCost) * parseInt(x.cooperationHour)
              )
              .reduce((a, b) => parseInt(a) + parseInt(b), 0)) +
        (this.proposal.travelExpenses.length == 0
          ? 0
          : this.proposal.travelExpenses
              .map((x) => x.cost)
              .reduce((a, b) => parseInt(a) + parseInt(b), 0)) +
        (this.proposal.purchases.length == 0
          ? 0
          : this.proposal.purchases
              .map((x) => parseInt(x.perPrice) * parseInt(x.number))
              .reduce((a, b) => parseInt(a) + parseInt(b), 0)) +
        (this.proposal.otherCosts.length == 0
          ? 0
          : this.proposal.otherCosts
              .map((x) => x.totalPrice)
              .reduce((a, b) => parseInt(a) + parseInt(b), 0)) -
        (this.proposal.participationOrganizationBudget.length == 0
          ? 0
          : this.proposal.participationOrganizationBudget
              .map((x) => x.totalPrice)
              .reduce((a, b) => parseInt(a) + parseInt(b), 0));

      if (tempPrice > 0) return tempPrice;
      else return 0;
    },
  },

  mounted() {
    this.getInfo();
    setTimeout(() => {
      if (!this.isLoaded) {
        const title = (
          <div>
            <h5 class="text-center">...کندی سرعت اینترنت</h5>
            <span>
              به نظر میرسد سرعت اینترنت شما کمی کند است. لطفا برای بارگذاری
              اطلاعات بیشتر صبر کنید یا صفحه را رفرش کنید
            </span>
          </div>
        );
        this.toast(title, "warning");
        this.$bvModal.hide("loading");
      }
    }, this.isLoadedTimeOut);
  },
};
</script>

<style lang="scss">
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../../assets/fonts/IRANSans(FaNum).ttf");
}
</style>
